import React from 'react';
import Modal from 'react-modal';
import { mainModalStyle } from '../../lib/constants'

import ShipmentViewModal from '../../containers/shipments/shipment-view'
import TripViewModal from '../../containers/trips/trip-view'
import AdminUserEditModal from '../../containers/adminUsers/admin-user-edit'
import UserEditModal from '../../containers/users/user-edit'
import UserViewModal from '../../containers/users/user-view'
import MessageEditModal from '../../containers/message/message-edit'
import PricingEditModal from '../../containers/pricing/pricing-edit'
import NotificationEditModal from '../../containers/notifications/notification-edit'
import NotificationUserModal from '../../containers/notifications/notification-user'
import NotificationAllUserModal from '../../containers/notifications/notification-alluser'
import ProductEditModal from '../../containers/products/product-edit'
import ProductViewModal from '../../containers/products/product-view'
import CountryEditModal from '../../containers/countries/country-edit'
import CityEditModal from '../../containers/countries/cities/city-edit'
import StoryEditModal from '../../containers/countries/stories/story-edit'
import CategoryEditModal from '../../containers/products/categories/category-edit'
import StoreEditModal from '../../containers/products/stores/store-edit'
import FAQEditModal from '../../containers/settings/faq-edit'

import AdminUserCreateModal from '../../containers/adminUsers/admin-user-create'
import ShipmentCreateModal from '../../containers/shipments/shipment-create'
import NotificationCreateModal from '../../containers/notifications/notification-create'
import UserCreateModal from '../../containers/users/user-create'
import MessageCreateModal from '../../containers/message/message-create'
import ProductCreateModal from '../../containers/products/product-create'
import PricingCreateModal from '../../containers/pricing/pricing-create'
import CountryCreateModal from '../../containers/countries/country-create'
import CategoryCreateModal from '../../containers/products/categories/category-create'
import SubCategoryCreateModal from '../../containers/products/subCategories/sub-category-create'
import SubcategoryEditModal from '../../containers/products/subCategories/subcategory-edit'
import StoreCreateModal from '../../containers/products/stores/store-create'
import TripCreateModal from '../../containers/trips/trip-create'
import StoryCreateModal from '../../containers/countries/stories/story-create'
import CityCreateModal from '../../containers/countries/cities/city-create'
import FAQCreateModal from '../../containers/settings/faq-create'
import ShipmentAssignModal from '../../containers/shipments/shipment-assign'
import MakeOfferModal from '../../containers/shipments/make-offer';
import ConfirmDeleteModal from './confirm-delete'

const style = { ...mainModalStyle }
const MainModal = ({
  closeMainModal,
  openMainModal,
  modalVisible,
  recordId,
  modalVariant,
  reload,
  extraData
}) => {
  return (
    <Modal
      shouldCloseOnOverlayClick={true}
      isOpen={modalVisible}
      onRequestClose={() => closeMainModal()}
      overlayClassName="overlay"
      style={style}
    >
      {modalVariant === 'shipment-view' &&
        <ShipmentViewModal
          recordId={recordId}
          closeMainModal={closeMainModal}
          extraData={extraData}
        />
      }
      {modalVariant === 'shipment-assign' &&
        <ShipmentAssignModal
          recordId={recordId}
          closeMainModal={closeMainModal}
        />
      }
      {modalVariant === 'make-offer' &&
        <MakeOfferModal
          recordId={recordId}
          closeMainModal={closeMainModal}
        />
      }
      {modalVariant === 'trip-view' &&
        <TripViewModal
          recordId={recordId}
          closeMainModal={closeMainModal}
        />
      }
      {modalVariant === 'admin-user-edit' && recordId &&
        <AdminUserEditModal
          recordId={recordId}
          closeMainModal={closeMainModal}
          reload={reload}
        />
      }
      {modalVariant === 'user-edit' && recordId &&
        <UserEditModal
          recordId={recordId}
          closeMainModal={closeMainModal}
          reload={reload}
        />
      }
      
      {modalVariant === 'user-view' && recordId &&
        <UserViewModal
          recordId={recordId}
          closeMainModal={closeMainModal}
        />
      }

      {modalVariant === 'message-edit' && recordId &&
        <MessageEditModal
          recordId={recordId}
          closeMainModal={closeMainModal}
          reload={reload}
        />
      }
      {modalVariant === 'pricing-edit' && recordId &&
        <PricingEditModal
          recordId={recordId}
          closeMainModal={closeMainModal}
          reload={reload}
        />
      }

      {modalVariant === 'product-view' &&
        <ProductViewModal
          recordId={recordId}
          closeMainModal={closeMainModal}
        />
      }

      {modalVariant === 'product-edit' &&
        <ProductEditModal
          recordId={recordId}
          closeMainModal={closeMainModal}
          reload={reload}
        />
      }

      {modalVariant === 'country-edit' && recordId &&
        <CountryEditModal
          recordId={recordId}
          closeMainModal={closeMainModal}
          openMainModal={openMainModal}
          reload={reload}
        />
      }
      {modalVariant === 'city-edit' && recordId &&
        <CityEditModal
          recordId={recordId}
          closeMainModal={closeMainModal}
          reload={reload}
        />
      }

      {modalVariant === 'story-edit' &&
        <StoryEditModal
          recordId={recordId}
          closeMainModal={closeMainModal}
          reload={reload}
        />
      }

      {modalVariant === 'category-edit' && recordId &&
        <CategoryEditModal
          recordId={recordId}
          closeMainModal={closeMainModal}
          reload={reload}
        />
      }

      {modalVariant === 'store-edit' && recordId &&
        <StoreEditModal
          recordId={recordId}
          closeMainModal={closeMainModal}
          reload={reload}
        />
      }

      {/** create modals **/}
      {modalVariant === 'shipment-create' &&
        <ShipmentCreateModal
          closeMainModal={closeMainModal}
          reload={reload}
        />
      }
      {modalVariant === 'trip-create' &&
        <TripCreateModal
          closeMainModal={closeMainModal}
        />
      }

      {modalVariant === 'admin-user-create' &&
        <AdminUserCreateModal
          closeMainModal={closeMainModal}
          reload={reload}
        />
      }

      {modalVariant === 'user-create' &&
        <UserCreateModal
          closeMainModal={closeMainModal}
          reload={reload}
        />
      }
      {modalVariant === 'message-create' &&
        <MessageCreateModal
          closeMainModal={closeMainModal}
          reload={reload}
        />
      }
      {modalVariant === 'pricing-create' &&
        <PricingCreateModal
          closeMainModal={closeMainModal}
          reload={reload}
        />
      }



      {modalVariant === 'product-create' &&
        <ProductCreateModal
          closeMainModal={closeMainModal}
          reload={reload}
        />
      }

      {modalVariant === 'notification-create' &&
        <NotificationCreateModal
          closeMainModal={closeMainModal}
          reload={reload}
        />
      }

      {modalVariant === 'notification-edit' &&
        <NotificationEditModal
          recordId={recordId}
          closeMainModal={closeMainModal}
          reload={reload}
        />
      }

      {modalVariant === 'subcategory-edit' &&
        <SubcategoryEditModal
          recordId={recordId}
          closeMainModal={closeMainModal}
          reload={reload}
        />
      }

      {modalVariant === 'faq-edit' && recordId &&
        <FAQEditModal
          recordId={recordId}
          closeMainModal={closeMainModal}
          reload={reload}
        />
      }

      {modalVariant === 'notification-user' &&
        <NotificationUserModal
          recordId={recordId}
          closeMainModal={closeMainModal}
        />
      }
      {modalVariant === 'notification-alluser' &&
        <NotificationAllUserModal
          recordId={recordId}
          closeMainModal={closeMainModal}
        />
      }

      {modalVariant === 'country-create' &&
        <CountryCreateModal
          closeMainModal={closeMainModal}
          reload={reload}
        />
      }
      {modalVariant === 'faq-create' &&
        <FAQCreateModal
          closeMainModal={closeMainModal}
          reload={reload}
        />
      }

      {modalVariant === 'city-create' &&
        <CityCreateModal
          closeMainModal={closeMainModal}
        />
      }

      {modalVariant === 'category-create' &&
        <CategoryCreateModal
          closeMainModal={closeMainModal}
          reload={reload}
        />
      }

      {modalVariant === 'sub-category-create' &&
        <SubCategoryCreateModal
          closeMainModal={closeMainModal}
        />
      }

      {modalVariant === 'store-create' &&
        <StoreCreateModal
          closeMainModal={closeMainModal}
          reload={reload}
        />
      }

      {modalVariant === 'story-create' &&
        <StoryCreateModal
          closeMainModal={closeMainModal}
          reload={reload}
        />
      }

      {modalVariant && modalVariant.split('--')[1] === 'delete' &&
        <ConfirmDeleteModal
          closeMainModal={closeMainModal}
          type={modalVariant.split('--')[0]}
          recordId={recordId}
          reload={reload}
        />
      }
    </Modal>
  )
}
export default MainModal;